import { render, staticRenderFns } from "./KurehaQuiz.vue?vue&type=template&id=0a88a36e&scoped=true&"
import script from "./KurehaQuiz.vue?vue&type=script&lang=js&"
export * from "./KurehaQuiz.vue?vue&type=script&lang=js&"
import style0 from "./KurehaQuiz.vue?vue&type=style&index=0&id=0a88a36e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a88a36e",
  null
  
)

export default component.exports